import React from 'react';
import jMoment from 'moment-jalaali';
import { TableItemActionsNew , Icons} from 'components';
const PHIZIK_STATUS = {
  PHYSICAL_CARD_REQUEST_STATUS_LOGICALLY_ISSUED: 'صادر شده',
  PHYSICAL_CARD_STATUS_PRINT_REQUESTED: 'درخواست شده',
  PHYSICAL_CARD_STATUS_PRINTED: 'چاپ شده',
  PHYSICAL_CARD_STATUS_ACTIVATED: 'فعال شده',
  PHYSICAL_CARD_REQUESTED_STATUS_PRINT_FAIED: 'ناموفق',
};
const CARD_STATUS = {
  CARD_REQUESTED_STATUS_ACCEPTED: 'پذیرفته شده ',
  CARD_REQUESTED_STATUS_WAIT_ACTIVATE: 'در انتظار فعال شدن',
  CARD_REQUESTED_STATUS_ACTIVATED: 'فعال شده',
};
const columns = (requsetDuplicateCart, requsetBlockingCart, requsetPhysicalCard, actionActiveBonCart) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'نام',
    field: 'name',
    filtering: false,
    sorting: false,
    align: 'center',
  },
  {
    title: 'شناسه کاربر',
    field: 'userId',
    filtering: false,
    sorting: false,
    align: 'center',
  },

  {
    title: 'شناسه درخواست',
    field: 'id',
    filtering: false,
    sorting: false,
    align: 'center',
  },

  {
    title: 'تاریخ درخواست',
    field: 'requestDate',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rc) => jMoment(rc?.requestDate).format('dddd, jD jMMMM jYYYY'),
  },
  {
    title: 'تاریخ انقضا',
    field: 'expireDate',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rc) => jMoment(rc?.expireDate).format('dddd, jD jMMMM jYYYY'),
  },

  {
    title: 'شماره کارت',
    field: 'pan',
    filtering: false,
    sorting: false,
  },
  {
    title: 'شبا',
    field: 'shebaCode',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (row) => (row?.shebaCode ? `${row?.shebaCode}` : '-'),
  },
  {
    title: 'وضعیت درخواست فیزیکی کارت',
    field: 'physicalStatus',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (row) => (row?.physicalStatus ? `${PHIZIK_STATUS[row?.physicalStatus]}` : '-'),
  },

  {
    title: 'عملیات',
    field: '',
    filtering: false,
    sorting: false,
    align: 'right',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (row) => (
      <TableItemActionsNew
        iconButton
        startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
        title=""
        otherMenus={[
          {
            title: 'چاپ فیزیکی',
            isShow: true,
            onClick: () => {requsetPhysicalCard(row)},
            disabled: row?.physicalStatus == 'PHYSICAL_CARD_STATUS_PRINTED', // اگر چاپ شده باشد
          },
          {
            title: 'المثنی',
            isShow: true,
            onClick: () => {requsetDuplicateCart(row)},
          },
          {
            title: 'مسدودی',
            isShow: true,
            onClick: () => {requsetBlockingCart(row)},
          },

          {
            title: 'فعالسازی کارت',
            isShow: true,
            onClick: () => {actionActiveBonCart(row)},
            disabled: row?.cardStatus == 'CARD_REQUEST_STATUS_ACTIVATED',
          },
        ]}
      />
    ),
  },
];

const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      ...row,
    };
  });

  return newData;
};

export { columns, generateData };
